export default __webpack_public_path__ + "static/media/thrash-blue.beb00eef.svg";